export default __webpack_public_path__ + "static/media/icon-infor-2.4dd1c555.svg";